<template>
  <div class="d-flex justify-content-center">
    <Transition
      name="fade"
      mode="out-in"
      appear>
      <div
        v-if="$slots['secondary-button']"
        class="d-flex flex-column align-items-center gap-md w-100">
        <div class="d-flex justify-content-center gap-md w-100">
          <slot
            name="secondary-button"
            button-class="w-100"/>
          <slot
            name="primary-button"
            button-class="w-100"/>
        </div>
        <slot
          v-if="$slots['bottom-button']"
          name="bottom-button"
          :button-class="isMobile ? 'w-100' : 'w-50'"/>
      </div>
      <div
        v-else
        class="d-flex gap-md"
        :class="isMobile ? 'flex-column w-100' : 'flex-row-reverse'"
        :style="isMobile ? {} : { width: '275px' }">
        <slot
          name="primary-button"
          button-class="w-100"/>
        <slot
          v-if="$slots['secondary-button']"
          name="secondary-button"
          button-class="w-100"/>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import useScreenSize from '@shared/composables/screenSize.js'

const { isMobile } = useScreenSize()
</script>

<style lang="scss" scoped>
:deep(.base-button.stylist) {
  width: unset;
}
</style>
